import React from "react";
import JimPamIcon from "../assets/jim-pam-icon-out-trans.png";
import { useBrand } from "../branding/BrandContext";

export default function Logo() {
  const brand = useBrand();

  return (
    <div className="logo" aria-label={brand.logoAlt}>
      <div aria-hidden="true">
        <img
          src={JimPamIcon}
          alt=""
          className="logoImage"
        />
      </div>

      <div className="logoText">
        <span className="brand">
          {brand.brandName}<sup className="regtrade">TM</sup><span className="brand_small">.com</span>
        </span>

        <div className="tagline">{brand.consumerByline}</div>
      </div>
    </div>
  );
}
